import React from 'react';
import NumberField from '@/forms/_fields_v2/NumberField';
import { PlusIcon } from '@heroicons/react/24/outline';

export default function NumberFilter({ icon = PlusIcon, ...rest }) {
  return <NumberField {...rest} icon={icon} />;
}

NumberFilter.propTypes = {
  ...NumberField.propTypes,
};

NumberFilter.defaultProps = {
  ...NumberField.defaultProps,
};
